<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">프로필사진</td>
                <td>
                    <el-upload
                            class="avatar-uploader"
                            action=""
                            list-type="picture-card"
                            :show-file-list="false"
                            :file-list="files"
                            :auto-upload="false"
                            :on-change="onlyOnePhotoChange"
                    >
                        <img v-if="hasImage()" :src="files[0].url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="input_error pt0 pb0">크기 128 x 128 에 최적화 되어있습니다.</div>
                    <div class="input_error" v-html="validation.firstError('files') "></div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">가입신청일</td>
                <td>
                    <div>
                        <el-input v-model="c_date" readonly></el-input>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">
                    등록일
                </td>
                <td class="">
                    <div class="filter-select-div el-filter-date pt0 pb0">
                        <span class="filter-select-div el-filter-date">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                                class="el-date-common el-date-month"
                                v-model="date"
                                prefix-icon=" "
                                type="datetime"
                                format="yyyy-MM-dd HH:mm"
                                value-format="yyyy-MM-dd HH:mm"
                                placeholder="등록일"
                                @change="parentChange('date',date)"
                                clear-icon="none"
                                :picker-options="pickerOptions"
                        ></el-date-picker>
                        </span>
                        <div class="input_error" v-html="validation.firstError('date') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">이름</td>
                <td>
                    <div>
                        <el-input v-model="name" maxlength="10" @input="parentChange('name', name)"></el-input>
                        <div class="input_error" v-html="validation.firstError('name') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">직업</td>
                <td>
                    <div>
                        <el-input v-model="job" maxlength="20" @input="parentChange('job', job)"></el-input>
                        <div class="input_error" v-html="validation.firstError('job') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">
                    생년월일
                </td>
                <td class="">
                    <div class="filter-select-div el-filter-date pt0 pb0">
                        <span class="filter-select-div el-filter-date">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                                class="el-date-common el-date-month"
                                v-model="birth"
                                prefix-icon=" "
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                placeholder="생년월일"
                                @change="parentChange('birth',birth)"
                                clear-icon="none"
                                :picker-options="pickerOptions"
                        ></el-date-picker>
                        </span>
                        <div class="input_error" v-html="validation.firstError('birth') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">휴대전화</td>
                <td>
                    <div>
                        <el-input v-model="phone" maxlength="12" @input="parentChange('phone', phone)"></el-input>
                        <div class="input_error" v-html="validation.firstError('phone') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">이메일</td>
                <td>
                    <div>
                        <el-input v-model="email" maxlength="40" @input="parentChange('email', email)"></el-input>
                        <div class="input_error" v-html="validation.firstError('email') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">주소</td>
                <td>
                    <div>
                        <el-select v-model="addr1" class="select" placeholder="지역1" @change="selectSi(addr1)">
                            <el-option :label="si.ac_si" :value="si.ac_idx" v-for="si in siList" :key="si.ac_idx"></el-option>
                        </el-select>
                        <el-select v-model="addr2" class="select" placeholder="지역2" @change="selectGu(addr2)" :disabled="hasGu()">
                            <el-option :label="gu.ac_gu" :value="gu.ac_idx" v-for="gu in guList" :key="gu.ac_idx"></el-option>

                        </el-select>
                        <div class="input_error" v-html="validation.firstError('addr2') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">자기소개</td>
                <td>
                    <div>
                        <el-input v-model="memo" type="textarea"
                                  :rows="5" maxlength="500" @input="parentChange('memo', memo)"></el-input>
                        <div class="input_error" v-html="validation.firstError('memo') "></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">홈페이지 노출</td>
                <td>
                    <div>
                        <el-select v-model="mDisplay" class="select" @change="parentChange('mDisplay', mDisplay)">
                            <el-option :label="`노출`" :value="1"></el-option>
                            <el-option :label="`미노출`" :value="0"></el-option>
                        </el-select>
                    </div>
                </td>
            </tr>
          <tr>
            <td class="c_t_title">추천인</td>
            <td><el-input class="recommender_input" disabled :value="memberData.m_recommender"></el-input></td>
          </tr>
        </table>
    </div>
</template>

<script>
    import memberValidators from "@/mixins/validators/memberValidator";
    import elFileMixins from "@/mixins/elFileMixins";
    import util from "@/mixins/util";
    export default {
        name: "MemberWriteWaitLayout",
        mixins: [memberValidators, elFileMixins,],
        components: {},
        inject: ['memberWriteSetData'],
        provide() {
            return {}
        },
        props: {
            memberData: {},
        },
        data() {
            return {
                files:[],
                pickerOptions: { //데이트피커 옵션
                    disabledDate(time) {
                        let nowDate = new Date();
                        return time.getTime() > nowDate;
                    },
                },
                siList:[],
                guList:[],

            }
        },
        created() {
        },
        mounted() {
            this.initData();
            this.getSiList()
        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
        },
        methods: {
            initData() {
                if(util.isEmpty(this.memberData)) {
                    return false;
                }

                this.name = this.memberData.m_name;
                this.parentChange('name', this.name);
                this.mDisplay = this.memberData.m_display;
                this.parentChange('mDisplay', this.mDisplay);
                this.date = this.memberData.m_add_date;
                this.parentChange('date', this.date);
                this.job = this.memberData.m_job;
                this.parentChange('job', this.job);
                this.birth = this.memberData.m_birth;
                this.parentChange('birth', this.birth);
                this.email = this.memberData.m_email;
                this.parentChange('email', this.email);
                this.phone = this.memberData.m_hp;
                this.parentChange('phone', this.phone);

                this.addr1 = this.memberData.ac_parent;
                this.parentChange('addr1', this.addr1);
                this.getGuList(this.addr1)
                this.addr2 = this.memberData.ac_idx;
                this.parentChange('addr2', this.addr2);

                this.memo = this.memberData.m_memo;
                this.parentChange('memo', this.memo);

                if(!util.isEmpty(this.memberData.profile)) {
                    this.memberData.profile[0].url = this.memberData.profile[0].org_url;
                    this.files = this.memberData.profile;
                    this.parentChange('files', this.files);
                }
                this.c_date = this.memberData.created_at;

            },
            parentChange(key, value) {
                this.memberWriteSetData(key, value);
            },
            hasImage() {
                return !util.isEmpty(this.files);
            },
            getSiList() {
                let params = {si: 1}
                try {
                    this.$api.$area.getArea(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnAreaType(res.Info.type)
                        if (type === true) {
                            this.siList = res.List
                        } else {
                            this.errorAlert(type)
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            selectSi(si) {
                this.parentChange('addr1',si)
                this.getGuList(si)
                this.addr2 = ''
            },
            selectGu(gu){
                this.parentChange('addr2',gu)
            },
            hasGu() {
                return util.isEmpty(this.guList)
            },
            getGuList(gu) {
                let params =
                    {gu: gu}
                try {
                    this.$api.$area.getArea(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnAreaType(res.Info.type)
                        if (type === true) {
                            this.guList = res.List
                        } else {
                            this.errorAlert(type)
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            returnAreaType(type) {
                switch (type) {
                    case 1:
                        return true
                    default:
                        return '지역 리스트를 불러올 수 없습니다.'
                }
            },
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>